/**
 * Association partner landing pages. Crawler HTML is built from this list so
 * `/partners/pcpa` is server-rendered (title, OG, noscript) without a DB round-trip.
 * Live discount still comes from Super Admin `associations` for the SPA.
 */

export type PartnerLanding = {
  slug: string;
  partnerSlug: string;
  name: string;
  title: string;
  description: string;
  keywords: string;
  headline: string;
  subhead: string;
  promoCode: string;
  discountPercent: number;
  trialDays: number;
};

export const PARTNER_LANDINGS: PartnerLanding[] = [
  {
    slug: '/partners/pcpa',
    partnerSlug: 'pcpa',
    name: 'PCPA',
    title: 'PCPA member pricing | 20% off forever — ServiceApp.ai',
    description:
      'PCPA members get 20% off ServiceApp forever on the plan and extra office users. 90-day Grow trial. Unlimited crew. Pay only for office users. Promo code PCPA20.',
    keywords: 'PCPA, PCPA20, association pricing, ServiceApp partner, 20% off ServiceApp',
    headline: 'PCPA member pricing',
    subhead:
      '20% off forever on your plan and extra office users. 90-day Grow trial. Unlimited crew. Pay only for office users.',
    promoCode: 'PCPA20',
    discountPercent: 20,
    trialDays: 90,
  },
];

export function getPartnerLandingByPath(pathname: string): PartnerLanding | undefined {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return PARTNER_LANDINGS.find((page) => page.slug === normalized);
}
